module.exports = __webpack_public_path__ + "img/edits-accepted-icon.59f2d3b1.png";